exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".secondary-color{color:var(--v-secondary-base)!important}", ""]);

// exports
